import { SparkSurveyForm } from 'external/SurveyJs';
import { useFormByID } from 'hooks/Forms';
import { useSparksByID } from 'hooks/spark';
import React from 'react';
import { SparkDialog } from 'sharedComponents/UI';

type Props = { open: boolean; onClose: () => void };

function CreateWithAI({ open, onClose }: Props) {
  const { spark } = useSparksByID('8bca53ee-f9cf-4c48-92c3-0def264bcdbf');
  const { form } = useFormByID(spark?.attributes.inputFormID);
  return (
    <SparkDialog open={open} onClose={onClose} title='Create spark with AI'>
      {!!form && (
        <SparkSurveyForm
          height='80vh'
          onComplete={async () => {}}
          formConfigJSON={form?.attributes.config || ''}
          showProgressBar='off'
          // onCompleting={handleSparkRunPermissions}
          // onValueChanged={handleValueChange}
          id={spark?.id || ''}
          // disabled={isFormDisabled || false}
        />
      )}
    </SparkDialog>
  );
}

export default CreateWithAI;
